export { default as CuratedCatalogPage } from './components/CuratedCatalogPage';
export const CuratedCatalogPageDynamic = () => import('./components/CuratedCatalogPage');

export { default as AssignedContentCatalogPage } from './components/AssignedContentCatalogPage';
export const AssignedContentCatalogPageDynamic = () => import('./components/AssignedContentCatalogPage');
